export class SaasItemSearchRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "query",
            "baseName": "query",
            "type": "string",
            "format": ""
        },
        {
            "name": "emailSearchFilter",
            "baseName": "emailSearchFilter",
            "type": "EmailSearchFilter",
            "format": ""
        },
        {
            "name": "startTime",
            "baseName": "startTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "endTime",
            "baseName": "endTime",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return SaasItemSearchRequest.attributeTypeMap;
    }
    constructor() {
    }
}
